import { Trans } from "@lingui/macro";
import { useInvoiceDetailsQuery } from "@smp/graphql";
import { UiBox, UiButton, UiTypography } from "@smp/ui";
import { REACT_APP__IS_FOREIGN } from "@smp/utils";
import { useToggle } from "react-use";

import { gqlClient } from "@/hooks/use_graphql";
import { InvoiceForm } from "@/screens/app/components/invoice_form";

import classes from "./organization_invoice.module.css";

export const OrganizationInvoice = () => {
  const [isFormVisible, toggleFormVisible] = useToggle(false);
  const { data: invoiceDetailsData, isLoading: isInvoiceDetailsDataLoading } =
    useInvoiceDetailsQuery(gqlClient);

  if (isInvoiceDetailsDataLoading) return null;

  const invoice_entity = String(
    invoiceDetailsData?.invoice_details.invoice_entity,
  );

  const isOrganizationMode = invoice_entity === "legal_entity";

  const invoiceNaturalData = invoiceDetailsData?.invoice_details.natural_person;

  const invoiceLegalData = invoiceDetailsData?.invoice_details.legal_entity;

  const isNaturalDataExist =
    invoiceNaturalData &&
    Object.values(invoiceNaturalData).some((dataItem) => dataItem !== "");

  const isLegalDataExist =
    invoiceLegalData &&
    Object.values(invoiceLegalData).some((dataItem) => dataItem !== "");

  const noDataExist = !isNaturalDataExist && !isLegalDataExist;

  const isOrganizationNameExist = !!invoiceLegalData?.organization_name;

  const isFirstNameExist = !!invoiceNaturalData?.first_name;
  const isLastNameExist = !!invoiceNaturalData?.last_name;

  const isVatExist = !!invoiceNaturalData?.vat_id;

  const addressLine = [
    invoiceLegalData?.address,
    invoiceLegalData?.postal_code,
    invoiceLegalData?.city,
    invoiceLegalData?.country,
  ]
    .filter(Boolean)
    .join(", ");

  if (!REACT_APP__IS_FOREIGN) return null;

  return (
    <>
      <UiBox mb={2}>
        <UiTypography variant="h4">
          <Trans>Invoice</Trans>
        </UiTypography>
      </UiBox>

      <UiBox>
        {noDataExist ? (
          <UiButton
            color="primary"
            variant="outlined"
            onClick={toggleFormVisible}
          >
            <Trans>Add invoice details</Trans>
          </UiButton>
        ) : (
          <UiBox className={classes.info}>
            {isOrganizationMode && isOrganizationNameExist && (
              <UiTypography>{invoiceLegalData.organization_name}</UiTypography>
            )}
            {(isFirstNameExist || isLastNameExist) && (
              <UiTypography>
                {invoiceNaturalData.first_name + " " || ""}
                {invoiceNaturalData.last_name || ""}
              </UiTypography>
            )}
            {isVatExist && (
              <UiTypography>{invoiceNaturalData.vat_id}</UiTypography>
            )}
            {addressLine && <UiTypography>{addressLine}</UiTypography>}
          </UiBox>
        )}
      </UiBox>

      {isFormVisible && (
        <div className={classes.form}>
          <InvoiceForm isModal onClose={toggleFormVisible} />
        </div>
      )}
    </>
  );
};
